import React, { useEffect, useState, useContext } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import AdminNav from '../adminNav';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import noData from '../no-data.png';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import LanguageIcon from '@mui/icons-material/Language';
import axios from 'axios';
import '../admin.css';
import { useNavigate } from 'react-router-dom';
import { userContext } from '../../../contexts/userContext';
export default function AllResturent() {
  const { userType, userId } = useContext(userContext);
    const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  // Form state (for quick add only)
  const [resturentName, setResturentName] = useState('');

  const getAllRestaurants = () => {
    const token = localStorage.getItem('auth-token');
    axios
      .get('/getAllResturents', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((result) => {
        setRestaurants(result.data.resturents || []);
      })
      .catch((err) => {
        console.error('Error fetching restaurants:', err);
      });
  };
  const getAllRestaurantsByUserId = () => {
    const token = localStorage.getItem('auth-token');
    axios
      .get(`/getAllResturentsByUserId/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((result) => {
        setRestaurants(result.data.resturents || []);
      })
      .catch((err) => {
        console.error('Error fetching restaurants:', err);
      });
  };

  useEffect(() => {
    if (userType == 1) {
      getAllRestaurants();
    } else if (userType == 4) {
      getAllRestaurantsByUserId();
    }
  }, []);

  const handleOpen = () => {
    resetForm();
    setOpen(true);
  };

  const handleEdit = (row) => {
    // Navigate to edit page with restaurant ID
    navigate(`/EditResturent/${row._id}`);
  };

  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  const resetForm = () => {
    setResturentName('');
  };

  const handleClickOpenDelete = (id) => {
    setDeleteDialogOpen(true);
    setDeleteId(id);
  };

  const handleCloseDelete = () => {
    setDeleteDialogOpen(false);
  };

  const addRestaurant = () => {
    const token = localStorage.getItem('auth-token');
    const formData = new FormData();
    formData.append('resturentName', resturentName);
    formData.append('categories', JSON.stringify([]));

    axios
      .post('/addResturent', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        getAllRestaurants();
        handleClose();
      })
      .catch((err) => {
        console.error('Error adding restaurant:', err);
      });
  };


  const deleteRestaurant = () => {
    const token = localStorage.getItem('auth-token');
    axios
      .delete(`/deleteResturent/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        getAllRestaurants();
        handleCloseDelete();
      })
      .catch((err) => {
        console.error('Error deleting restaurant:', err);
      });
  };

  const regenerateQRCode = (id) => {
    const token = localStorage.getItem('auth-token');
    axios
      .post(`/regenerateQRCode/${id}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        getAllRestaurants();
        alert('QR Code regenerated successfully!');
      })
      .catch((err) => {
        console.error('Error regenerating QR code:', err);
        alert('Failed to regenerate QR code');
      });
  };

  return (
    <>
      <AdminNav />
      <Container className="" maxWidth="xl">
        <div className="title-with-search">
          <h2>All Menu</h2>
          {(userType == 1 )  && <Button onClick={() => navigate('/AddResturent')} className="new-btn" variant="contained">
            Add New Menu
          </Button>}
        </div>
        {restaurants.length === 0 ? (
          <div className="image-no-data-div">
            <img src={noData} alt="No data" />
          </div>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="restaurants table">
                <TableHead>
                  <TableRow>
                    <TableCell>Image</TableCell>
                    <TableCell>Restaurant Name</TableCell>
                    <TableCell>Language</TableCell>
                    <TableCell>Categories</TableCell>
                    <TableCell>QR Code</TableCell>
                    <TableCell>Menu Link</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {restaurants.map((row) => (
                    <TableRow
                      key={row._id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        {row.resturentImage ? (
                          <img 
                            src={row.resturentImage} 
                            alt={row.resturentName}
                            style={{ 
                              width: '60px', 
                              height: '60px', 
                              objectFit: 'cover',
                              borderRadius: '8px'
                            }}
                          />
                        ) : (
                          <Box 
                            sx={{ 
                              width: '60px', 
                              height: '60px', 
                              bgcolor: 'grey.200',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            <Typography variant="caption" color="text.secondary">
                              No Image
                            </Typography>
                          </Box>
                        )}
                      </TableCell>
                      <TableCell>{row.resturentName}</TableCell>
                      <TableCell>
                        {row.isBilingual ? (
                          <Chip
                            icon={<LanguageIcon />}
                            label="AR / EN"
                            size="small"
                            sx={{
                              bgcolor: '#86C85D',
                              color: 'white',
                              fontWeight: 600,
                              '& .MuiChip-icon': {
                                color: 'white'
                              }
                            }}
                          />
                        ) : (
                          <Chip
                            label="EN"
                            size="small"
                            variant="outlined"
                            sx={{
                              borderColor: 'grey.400',
                              color: 'grey.600'
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell>{row.categories?.length || 0}</TableCell>
                      <TableCell>
                        {row.qr ? (
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start' }}>
                            <img 
                              src={row.qr} 
                              alt="QR Code" 
                              style={{ width: '80px', height: '80px', cursor: 'pointer' }}
                              onClick={() => window.open(row.qr, '_blank')}
                            />
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => window.open(row.qr, '_blank')}
                              sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                            >
                              Download
                            </Button>
                          </Box>
                        ) : (
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => regenerateQRCode(row._id)}
                            sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                          >
                            Generate QR
                          </Button>
                        )}
                      </TableCell>
                      <TableCell>
                        {row.menuLink ? (
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => window.open(row.menuLink, '_blank')}
                            sx={{ textTransform: 'none' }}
                          >
                            View Menu
                          </Button>
                        ) : (
                          <Typography variant="body2" color="text.secondary">-</Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <EditIcon
                          onClick={() => handleEdit(row)}
                          className="grey-icon"
                          style={{ marginRight: '10px', cursor: 'pointer' }}
                        />
                        <DeleteIcon
                          onClick={() => handleClickOpenDelete(row._id)}
                          className="cancel-icon"
                          style={{ cursor: 'pointer' }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        {/* Add Restaurant Dialog */}
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>Add New Restaurant</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
              <TextField
                required
                label="Restaurant Name"
                value={resturentName}
                onChange={(e) => setResturentName(e.target.value)}
                fullWidth
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={addRestaurant} variant="contained">
              Add
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <Dialog open={deleteDialogOpen} onClose={handleCloseDelete}>
          <DialogTitle>Delete Restaurant</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete this restaurant? This action cannot be
              undone.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDelete}>Cancel</Button>
            <Button onClick={deleteRestaurant} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
}
